import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const Edit = ({ rowid, getData, closeEdit, getPesan, setMsg }) => {

    const [loading, setLoading] = useState(false)
    const [fileInput, setFileInput] = useState(null)
    const [oldFileUrl, setOldFileUrl] = useState('')

    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    const [formData, setFormData] = useState({
        noPksDpmptsp: '',
        tanggalPksDibuat: '',
        namaVendor: '',
        namaVendorPenanggungJawab: '',
        namaOwner: '',
        namaOwnerPenanggungJawab: '',
        judulPengadaan: '',
        nilaiPenawaran: 0,
        nilaiTransaksi: 0,
        tanggalPengajuan: '',
        tanggalMulai: '',
        tanggalSelesai: '',
        durasiKontrak: ''
    })

    // 1. Tarik data lama berdasarkan ID pas form dibuka
    useEffect(() => {
        const getDetailData = async () => {
            try {
                const response = await axiosJWT.get(`/api/pks-mandiri/detail/${rowid}`)
                const data = response.data

                // Map data dari DB ke state form, potong format date ISO (YYYY-MM-DD) biar masuk ke input type="date"
                setFormData({
                    noPksDpmptsp: data.noPksDpmptsp || '',
                    tanggalPksDibuat: data.tanggalPksDibuat ? data.tanggalPksDibuat.split('T')[0] : '',
                    namaVendor: data.namaVendor || '',
                    namaVendorPenanggungJawab: data.namaVendorPenanggungJawab || '',
                    namaOwner: data.namaOwner || '',
                    namaOwnerPenanggungJawab: data.namaOwnerPenanggungJawab || '',
                    judulPengadaan: data.judulPengadaan || '',
                    nilaiPenawaran: data.nilaiPenawaran || 0,
                    nilaiTransaksi: data.nilaiTransaksi || 0,
                    tanggalPengajuan: data.tanggalPengajuan ? data.tanggalPengajuan.split('T')[0] : '',
                    tanggalMulai: data.tanggalMulai ? data.tanggalMulai.split('T')[0] : '',
                    tanggalSelesai: data.tanggalSelesai ? data.tanggalSelesai.split('T')[0] : '',
                    durasiKontrak: data.durasiKontrak || ''
                })

                setOldFileUrl(data.signedFile || '')
            } catch (err) {
                getPesan()
                setMsg('Gagal mengambil detail data!')
            }
        }

        if (rowid) getDetailData()
    }, [rowid])

    // 2. Hitung otomatis durasi kontrak pas tgl mulai/selesai diubah
    useEffect(() => {
        if (formData.tanggalMulai && formData.tanggalSelesai) {
            const durasi = hitungDurasi(formData.tanggalMulai, formData.tanggalSelesai)
            setFormData(prev => ({ ...prev, durasiKontrak: durasi }))
        }
    }, [formData.tanggalMulai, formData.tanggalSelesai])

    const hitungDurasi = (start, end) => {
        if (!start || !end) return ''
        const startDate = new Date(start)
        const endDate = new Date(end)

        let years = endDate.getFullYear() - startDate.getFullYear()
        let months = endDate.getMonth() - startDate.getMonth()
        let days = endDate.getDate() - startDate.getDate()

        if (days < 0) {
            months--
            const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
            days += prevMonth.getDate()
        }
        if (months < 0) {
            years--
            months += 12
        }

        let result = []
        if (years > 0) result.push(`${years} Tahun`)
        if (months > 0) result.push(`${months} Bulan`)
        if (days > 0) result.push(`${days} Hari`)

        return result.join(' ')
    }

    const prosesUpdate = async (e) => {
        e.preventDefault()
        setLoading(true)

        const dataToSend = new FormData()

        // Masukin text/number field
        Object.keys(formData).forEach(key => {
            dataToSend.append(key, formData[key])
        })

        // Kalau ada file baru, kirim file barunya bray. Kalau gak ada, backend pake yang lama.
        if (fileInput) {
            dataToSend.append('signedFile', fileInput)
        }

        try {
            // 🔥 Sesuaikan endpoint update lo bray, pake rowid
            const response = await axiosJWT.put(`/api/pks-mandiri/update/${rowid}`, dataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            getPesan()
            setMsg(response.data.msg)
            setTimeout(() => {
                getPesan()
                setMsg('')
                getData('')
                closeEdit()
            }, 2000)
        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pembaruan data gagal!'
            setMsg(errorMsg)
            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 4000)
        } finally {
            setLoading(false)
        }
    }

    const openFile = (url) => {
        setFileUrl(url)
        setShowModalFile(true)
    }

    return (<>
        <form onSubmit={prosesUpdate} className="form-horizontal" encType="multipart/form-data">
            <div className="row">

                {/* Row 1: Nomor PKS Utama */}
                <div className="form-group col-md-12">
                    <label className="control-label">Nomor PKS</label>
                    <input type="text" className="form-control" value={formData.noPksDpmptsp} onChange={(e) => setFormData({ ...formData, noPksDpmptsp: e.target.value })} required />
                </div>

                {/* Row 2: Kronologi Tanggal */}
                <div className="form-group col-md-6">
                    <label className="control-label">Tanggal Dokumen PKS Dibuat</label>
                    <input type="date" className="form-control" value={formData.tanggalPksDibuat} onChange={(e) => setFormData({ ...formData, tanggalPksDibuat: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Tanggal Pengajuan Kontrak</label>
                    <input type="date" className="form-control" value={formData.tanggalPengajuan} onChange={(e) => setFormData({ ...formData, tanggalPengajuan: e.target.value })} />
                </div>

                {/* Row 3: Judul Kegiatan */}
                <div className="form-group col-md-12">
                    <label className="control-label">Judul Pengadaan / Nama Kegiatan</label>
                    <input type="text" className="form-control" value={formData.judulPengadaan} onChange={(e) => setFormData({ ...formData, judulPengadaan: e.target.value })} required />
                </div>

                {/* Row 4: Identitas Pihak */}
                <div className="form-group col-md-6">
                    <label className="control-label">Pihak Kesatu (Nama Badan)</label>
                    <input type="text" className="form-control" value={formData.namaOwner} onChange={(e) => setFormData({ ...formData, namaOwner: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Pihak Kesatu (Penanggung Jawab)</label>
                    <input type="text" className="form-control" value={formData.namaOwnerPenanggungJawab} onChange={(e) => setFormData({ ...formData, namaOwnerPenanggungJawab: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Pihak Kedua (Nama Badan/Usaha)</label>
                    <input type="text" className="form-control" value={formData.namaVendor} onChange={(e) => setFormData({ ...formData, namaVendor: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Pihak Kedua (Penanggung Jawab)</label>
                    <input type="text" className="form-control" value={formData.namaVendorPenanggungJawab} onChange={(e) => setFormData({ ...formData, namaVendorPenanggungJawab: e.target.value })} required />
                </div>

                {/* Row 5: Nilai Anggaran */}
                <div className="form-group col-md-6">
                    <label className="control-label">Nilai Penawaran (Rp)</label>
                    <input type="number" className="form-control" value={formData.nilaiPenawaran} onChange={(e) => setFormData({ ...formData, nilaiPenawaran: e.target.value })} />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Nilai Transaksi Kontrak / PKS (Rp)</label>
                    <input type="number" className="form-control" value={formData.nilaiTransaksi} onChange={(e) => setFormData({ ...formData, nilaiTransaksi: e.target.value })} required />
                </div>

                {/* Row 6: Durasi Kontrak */}
                <div className="form-group col-md-4">
                    <label className="control-label">Tanggal Kontrak Mulai</label>
                    <input type="date" className="form-control" value={formData.tanggalMulai} onChange={(e) => setFormData({ ...formData, tanggalMulai: e.target.value })} required />
                </div>
                <div className="form-group col-md-4">
                    <label className="control-label">Tanggal Kontrak Selesai</label>
                    <input type="date" className="form-control" value={formData.tanggalSelesai} onChange={(e) => setFormData({ ...formData, tanggalSelesai: e.target.value })} required />
                </div>
                <div className="form-group col-md-4">
                    <label className="control-label">Durasi Kontrak (Otomatis)</label>
                    <input type="text" className="form-control" value={formData.durasiKontrak} readOnly style={{ backgroundColor: '#eee', fontWeight: 'bold' }} />
                </div>

                {/* Row 7: File Attachment */}
                <div className="form-group col-md-12">
                    <label className="control-label">Ubah Berkas Fisik PKS (Format: PDF)</label>
                    <div className="form-group is-empty is-fileinput" style={{ margin: 0, paddingBottom: 0 }}>
                        <input
                            type="file"
                            accept="application/pdf"
                            onChange={(e) => setFileInput(e.target.files[0])}
                        />
                        <div className="input-group">
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                placeholder={fileInput ? fileInput.name : "Pilih file PDF baru jika ingin mengubah..."}
                            />
                            <span className="input-group-btn input-group-sm">
                                <button type="button" className="btn btn-fab btn-fab-mini">
                                    <i className="fa fa-file-archive-o"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>

                {/* 🔥 Row 8: Box Preview Berkas Aktif */}
                {oldFileUrl && (
                    <div className="form-group col-md-12" style={{ marginTop: '10px' }}>
                        <div style={{
                            padding: '12px',
                            background: '#f9f9f9',
                            borderRadius: '4px',
                            border: '1px dashed #d9d9d9',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '6px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                <span className="text-success" style={{ fontWeight: 'bold', fontSize: '13px' }}>
                                    Berkas PKS Aktif Saat Ini:
                                </span>
                                <a
                                    onClick={() => openFile(oldFileUrl)}
                                    className="btn btn-xs btn-raised btn-info br-2"
                                    style={{ padding: '4px 12px', fontSize: '11px', textTransform: 'none', display: 'inline-flex', alignItems: 'center', gap: '5px', margin: 0 }}
                                >
                                    <i className="fa fa-file-pdf-o"></i> Lihat Dokumen Aktif
                                </a>
                            </div>
                            <small className="text-muted" style={{ fontStyle: 'italic', fontSize: '11px' }}>
                                *Catatan: Jika tidak ingin mengganti berkas fisik, biarkan pilihan file di atas kosong.
                            </small>
                        </div>
                    </div>
                )}

            </div>

            <div className="modal-footer" style={{ marginTop: '20px' }}>
                <button disabled={loading} className="btn btn-raised btn-primary br-2" type="submit">
                    <i className="fa fa-refresh"></i> {loading ? 'Memperbarui...' : 'Simpan Perubahan'}
                </button>
                <button className="btn btn-raised btn-danger br-2" type="button" onClick={closeEdit}><i className="fa fa-sign-out"></i> Tutup</button>
            </div>
        </form>

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-md">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalFile(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview File</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}
    </>)
}